export function fetch(id) { return { type: 'MEDALS/FETCH', id } }
export function fetchFull(id) { return { type: 'MEDALS/FETCH/FULL', id } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/medals.js